import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import FixedItineraryDrawer from "components/drawer/FixedItineraryDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewFixedItineraryModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import RemarkModal from "components/modal/RemarkModal";
import FixedItineraryServices from "services/FixedItineraryServices";
import { notifyError } from "utils/toast";
import ShowHideButton from "components/table/ShowHideButton";

const FixedItineraryTable = ({
  fixedItinerary,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const {
    title,
    serviceId,
    serviceBlock,
    handleModalOpen,
    handleView,
    handleUpdate,
    isViewMode,
  } = useToggleDrawer();
 
  const [viewData, setViewData] = useState("");

  const GetItinerary = async (id) => {
    try {
      const res = await FixedItineraryServices.getFixedItineraryById(id);
      if (res) {
        setViewData(res);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err.message);
    }
  };
  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={viewData} />

      <MainDrawer>
        <FixedItineraryDrawer id={serviceId} isViewMode={isViewMode} />
      </MainDrawer>

      <TableBody>
        {Array.isArray(fixedItinerary) &&
          fixedItinerary?.slice(0, perpage).map((data, index) => (
                <TableRow key={data.id}>
                      <TableCell
                        className="text-center text-sm"
                      >
                        {(currentPage - 1) * perpage + index + 1}
                      </TableCell>

                      <TableCell
                        className="text-center text-sm"
                      >
                        {data.package_code}
                      </TableCell>

                      <TableCell
                        className="text-center text-sm"
                        style={{
                          maxWidth: "250px",
                          overflowWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {data.route}
                      </TableCell>

                      <TableCell
                        className="text-center text-sm"
                      >
                        {data.no_of_days}/{data.no_of_nights}
                      </TableCell>

                  <TableCell className="text-center" >
                <ShowHideButton
                                      id={data.id}
                                      status={data.is_active}
                                      Loading={true}
                                    />
                </TableCell>

                    <TableCell
                      className="text-right"
                    >
                      <div className="flex justify-center">
                        <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                          <button
                            onClick={() => {
                              handleView(data.id);
                              GetItinerary(data.id);
                            }}
                            className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                          >
                            <Tooltip
                              id={data.id}
                              Icon={FiEye}
                              title="ViewOrder"
                              bgColor="#34D399"
                            />
                          </button>
                        </div>
                        <EditDeleteButton
                          title={"FixedItinerary"}
                          id={data.id}
                          handleUpdate={handleUpdate}
                          handleModalOpen={handleModalOpen}
                          hideDelete={hideDelete}
                          hideEdit={hideEdit}
                        />
                      </div>
                    </TableCell>
                </TableRow>
          ))}
      </TableBody>
    </>
  );
};

export default FixedItineraryTable;
